import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { LoanDetails } from '../../../../../../../model/finzy-flex/loan-list.model';
import { BorrowerDetail } from '../../../../../../../../app/model/finzy-flex/borrower.model'
import { BorrowerService } from '../../../../../../../service/finzy-flex/borrower/borrower.service';
import { LoanStatus } from '../../../../../../../model/loan-status.model';
import { LoanSuggestedTermPopUpComponent } from '../../../../../../../shared/loan-suggested-term-pop-up/loan-suggested-term-pop-up.component';
import { Keys, StorageService } from '../../../../../../../service/storage.service';
import { LoanSuggestedTermService } from '../../../../../../../service/rbi-compliance/loan-suggested-term.service';
import { LOAN_SUGGESTED_TERM, LoanSuggestedTerm, UserSuggestedTerm } from '../../../../../../../model/rbi-compliance/loan-suggested-term.model';
import { Toaster, Type } from '../../../../../../../toaster/Toaster';
import { ConfirmPopUpFinzyFlexComponent } from '../../../../confirm-pop-up-finzy-flex/confirm-pop-up-finzy-flex.component';
import { WithdrawnSuccessPopUpComponent } from '../../../../../../../shared/withdrawn-success-pop-up/withdrawn-success-pop-up.component';
import { first } from 'lodash';

@Component({
	selector: 'app-borrower-details-pop-up',
	templateUrl: './borrower-details-pop-up.component.html',
	styleUrls: ['./borrower-details-pop-up.component.css']
})
export class BorrowerDetailsPopUpComponent implements OnInit {
	private readonly borrowerService: BorrowerService;

	public borrowerDetail: BorrowerDetail;
	public loan: LoanDetails;
	public showLoader: boolean = true;
	public loanSuggestedTerm: LoanSuggestedTerm;

	private readonly dialogRef: MatDialogRef<BorrowerDetailsPopUpComponent>;

	constructor(
		@Inject(MAT_DIALOG_DATA) loan: LoanDetails,
		borrowerService: BorrowerService,
		dialogRef: MatDialogRef<BorrowerDetailsPopUpComponent>,
		private readonly storageService: StorageService,
		private readonly loanSuggestedTermService: LoanSuggestedTermService,
		public dialog: MatDialog) {
		this.loan = loan;
		this.borrowerService = borrowerService;
		this.dialogRef = dialogRef;
	}

	async ngOnInit() {
		await this.getBorrowerBasicDetail();
		console.log(this.loan)
	}

	private async getBorrowerBasicDetail(): Promise<void> {
		await this.borrowerService.getBorrowerDetail(this.loan.borrowerId)
			.then(borrowerDetail => {
				this.borrowerDetail = borrowerDetail.data[0];
				this.getLoanSuggestedTermByLoanIdAndLenderId();
			})
	}

	public getLoanSuggestedTermByLoanIdAndLenderId(): void {
		const loanId = this.loan.loanId;
		const lenderId = this.storageService.getItem(Keys.LENDER_ID);
		this.loanSuggestedTermService.getLoanSuggestedTermByLoanIdAndLenderId(loanId, lenderId)
			.then((res) => {
				if (res[0]) {
					this.loanSuggestedTerm = res[0];
				}
				this.showLoader = false;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	public updateLoanSuggestedTerm(): void {
		const userSuggestedTerm: UserSuggestedTerm = { ...this.loanSuggestedTerm.userSuggestedTerms[0], lenderStatus: LOAN_SUGGESTED_TERM.WITHDRAWN };
		const id = this.loanSuggestedTerm._id;
		this.loanSuggestedTermService.updateLoanSuggestedTerm(id, userSuggestedTerm)
			.then((res) => {
				this.dialog.closeAll();
				Toaster.toast('Updated Loan Terms Suggestion', Type.Success);
				this.dialog.open(WithdrawnSuccessPopUpComponent, { panelClass: 'withdrawn-success-dialog' }).afterClosed().subscribe((res) => { });
			})
			.catch((error) => {
				console.log('ERROR ', error);
			})
	}

	public populateLoanStatus(): string {
		if (LoanStatus.hasBeenAccepted(this.loan.loanStatus)) {
			return 'Active';
		}
		return '-';
	}

	public investmentNegotiationHandler(): void {
		this.dialogRef.close();
		const matDialogConfig: MatDialogConfig = {
			maxHeight: '90vh',
			width: '80%',
			panelClass: 'dialog-responsive',
			data: {
				loan: this.loan,
				borrowerDetail: this.borrowerDetail,
				loanSuggestedTerm: this.loanSuggestedTerm,
				isBorrower: false,
			}
		};
		this.dialog.open(LoanSuggestedTermPopUpComponent, matDialogConfig).afterClosed().subscribe((res) => {
			this.dialog.closeAll();
		});
	}

	public isShowSuggestedLoanTermButton(): boolean {
		try {
			if (!(this.loanSuggestedTerm && this.loanSuggestedTerm?.userSuggestedTerms?.length) && (LoanStatus.hasToShowLoanSuggestedTerm(this.loan.loanStatus))) {
				return true;
			}
			return false;
		} catch (e) {
			return false;
		}
	}

	public async investmentNegotiationWithdrawnHandler(): Promise<any> {
		// const result = await this.onOpenConfirmationPopup({
		// 	data: {
		// 		title: 'Are you Sure',
		// 		subTitle: 'Do you want to withdraw?',
		// 		message: `By confirming, Indicated Tenure and Indicated Loan Rate will be get applied.`,
		// 		positiveButtonText: 'Confirm',
		// 		negativeButtonText: 'Back',
		// 	},
		// 	width: '60%',
		// 	minWidth: 'fit-content',
		// 	panelClass: 'disable-preference-popup'
		// });
		// if (result) {
		this.updateLoanSuggestedTerm();
		// }
	}

	public isShowLoanSuggestedTerm(): boolean {
		if ((this.loanSuggestedTerm) && (this.loanSuggestedTerm.userSuggestedTerms) && (this.loanSuggestedTerm.userSuggestedTerms.length)) {
			if (first(this.loanSuggestedTerm.userSuggestedTerms).lenderStatus === LOAN_SUGGESTED_TERM.WITHDRAWN) {
				return false;
			}
			return true;
		}
		return false;
	}

	private async onOpenConfirmationPopup(data): Promise<boolean> {
		return await this.dialog.open(ConfirmPopUpFinzyFlexComponent, data).afterClosed().toPromise();
	}
}
